import { GridAlignment, GridValueGetterParams } from "@mui/x-data-grid-pro";
import { format } from "date-fns";
import { Tag } from "entities/tags/types";
import { ThemeTag } from "entities/themeTags/types";
import DropdownList from "shared/components/DropdownList";
import { FilterOption } from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";

type ColumnsProps = {
  themeTagsDetailsDrawer: DrawerHookResult<ThemeTag>;
  setSelectedTag: (tag: ThemeTag) => void;
  setOpenModal: () => void;
  tagTypes: FilterOption[];
  readOnly: boolean;
};

export const getThemeTagsColumns = ({
  themeTagsDetailsDrawer,
  setSelectedTag,
  setOpenModal,
  tagTypes,
  readOnly,
}: ColumnsProps) => {
  const renderActions = (tag: ThemeTag) => {
    if (readOnly) {
      return (
        <FlexCenter onClick={() => themeTagsDetailsDrawer.openDrawer(tag)}>
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </FlexCenter>
      );
    }

    return (
      <DropdownList
        items={[
          {
            title: "Edit",
            onClick: () => {
              themeTagsDetailsDrawer.openDrawer(tag);
            },
          },
          {
            title: "Delete",
            style: "remove",
            onClick: () => {
              setSelectedTag(tag);
              setOpenModal();
            },
          },
        ]}
      />
    );
  };

  return [
    {
      field: "tagTypeName",
      headerName: "Primary tag",
      editable: false,
      sortable: false,
      flex: 1.5,
      renderCell: (params: GridValueGetterParams) =>
        tagTypes.find((tagType) => tagType.value === params.value)?.label,
    },
    {
      field: "name",
      headerName: "Secondary tag",
      editable: false,
      sortable: false,
      flex: 1.5,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        if (params.value) {
          return format(params.value, "dd MMM yyyy, HH:mm");
        }
      },
    },
    {
      field: "matchingGamesCount",
      headerName: "Matched Games",
      editable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "actions",
      flex: 0.5,
      headerName: "",
      sortable: false,
      editable: false,
      align: "right" as GridAlignment,
      headerAlign: "right" as GridAlignment,
      renderCell: (params: GridValueGetterParams) =>
        renderActions(params.row as Tag),
    },
  ];
};
